export default __webpack_public_path__ + "static/media/auth_bg.9e559f24.jpg";